import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class OperatorGuard  {
  constructor(private storageService: StorageService, private router: Router){}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const ssoOrFtp = this.storageService.getLocalStore("sso_or_ftp");
    if(ssoOrFtp){
      this.router.navigateByUrl('/404');
      return false;
    }else{
      return true;
    }
  }
  
}
